export default {
  get width () {
    return window.innerWidth;
  },
  get height () {
    return window.innerHeight;
  }
};



// WEBPACK FOOTER //
// ./src/lib/dom/viewport-size.js